import { buildSponsorshipReservationTerm, sponsorshipBaseTerms, sponsorshipStreamDateTerm, } from 'root/src/shared/descriptions/modules/howToEarnPointsModal';
import { PointsApplicationState } from 'root/src/server/modules/points/types/types';
// Legacy shows the scheduled stream date to anyone whose application is not rejected, so creators who
// had only applied, or were put on hold, saw a stream date they were never approved for. The redesign
// shows it only once the application is actually approved.
const redesignStreamDateTerm = Object.assign(Object.assign({}, sponsorshipStreamDateTerm), { visibilityCondition: ({ streamDate, dropEvent }) => Boolean(streamDate)
        && dropEvent.pointsApplicationState === PointsApplicationState.APPROVED });
// Same bullets as legacy, with two deliberate differences (see above, and the reservation bullet drops
// its trailing "After that, ..." wording, which creators reported as technically incorrect). The base
// bullets are reused rather than copied so the two lists cannot drift apart.
export const redesignSponsorshipTerms = [
    ...sponsorshipBaseTerms,
    redesignStreamDateTerm,
    buildSponsorshipReservationTerm({ includeExpiryConsequence: false }),
];
